/* eslint-disable jsx-a11y/anchor-is-valid */
import { useMemo } from "react";
import { useRemoteConfig } from "../firebase/RemoteConfigProvider";
import { Modal } from "antd";
import { appVersion } from "../helpers/format";

export default function ForceUpdate() {
	const { config } = useRemoteConfig();
	const update = config?.["cms_latest_version"] && JSON.parse(config["cms_latest_version"]);

	const isNewVersion = useMemo(() => {
		if (update && update?.version && update?.isForceUpdate && appVersion) {
			const oldParts = appVersion?.split(".").map(Number);
			const newParts = update?.version?.split(".").map(Number);

			for (let i = 0; i < Math.max(oldParts.length, newParts.length); i++) {
				const oldNum = oldParts[i] || 0;
				const newNum = newParts[i] || 0;
				if (newNum > oldNum) return true;
				if (newNum < oldNum) return false;
			}
			return false;
		}

		return false;
	}, [update, appVersion]);

	console.log("is new version: ", isNewVersion);

	const hotReload = () => {
		if ("caches" in window) {
			caches.keys().then((names) => {
				for (let name of names) caches.delete(name);
			});
		}
		localStorage.clear();
		window.location.href = window.location.origin + "?v=" + Date.now();
	};

	return (
		<div>
			{isNewVersion && (
				<Modal
					title={`New Version Available (v${update?.version})`}
					closable={false}
					open={true}
					cancelButtonProps={{ style: { display: "none" } }}
					okText="Reload to Update"
					onOk={hotReload}
				>
					<p>There are new features available, please update your app</p>

					<ul>
						<li>
							<a
								href="#"
								onClick={() => hotReload()}
							>
								Reload the page (CTRL + SHIFT + R)
							</a>
						</li>
						<li>Clear your browser cache</li>
						<li>Open in Incognito/Private mode or use a different browser</li>
					</ul>
					{/* <div>If the problem persists, please contact the administrator.</div> */}
				</Modal>
			)}
		</div>
	);
}
